<template>
  <el-popover
    v-if="isCatProp"
    trigger="focus"
    placement="top"
    :disabled="!hasTips"
    >
    <span
      style="display: block"
      v-for="(tip, tipIndex) in tips"
      v-html="tip"
      :key="tipIndex"></span>
    <el-input
      slot="reference"
      v-bind="props"
      :value="_value"
      @input="onInput"></el-input>
  </el-popover>
  <el-input
    v-else
    v-bind="props"
    :value="_value"
    @input="onInput"></el-input>
</template>

<script>
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins],
  props: ["props", "tipRule", "value", "isMultiComlexItem"],
  computed: {
    key() {
      return this.props.name
    },
    tips() {
      return this.tipRule || []
    },
    hasTips() {
      return this.tips.length
    },
    isCatProp() {
      return this.props.parentName === 'catProp'
    },
    _value() {
      if (this.isMultiComlexItem) {
        return this.value
      }
      return this.isCatProp ? this.tjbForm[this.key][0].valueName : this.tjbForm[this.key]
      // if(this.isCatProp) {
      //   if(this.tjbForm[this.key] && this.tjbForm[this.key].length) {
      //     return this.tjbForm[this.key][0].valueName
      //   } else {
      //     return ''
      //   }
      // } else {
      //   this.tjbForm[this.key]
      // }
    }
  },
  methods: {
    onInput(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v)
      }

      const newFormFields = {}
      if (this.isCatProp) {
        this.tjbForm[this.key][0].valueName = v
        this.tjbForm[this.key][0].displayName = v
        this.tjbForm[this.key][0].valueId = v
      }
      newFormFields[this.key] = this.isCatProp ? this.tjbForm[this.key] : v
      this.updateTjbForm(newFormFields)
    },
  },
}
</script>

<style></style>